<section class="add-customer">
    <div>
        <div class="row">
            <div class="col-lg-6">
                <div class="table-content-card ml-0">
                    <div class="custom-header mb-5">
                        <h3 class="m-0">أضف عميل</h3>
                    </div>
                    <div class="custom-form">
                        <form [formGroup]="customForm">
                            <div class="row">
                                <!--            NAME-->
                                <div class="col-lg-6 mb-5">
                                    <span class="p-float-label">
                                        <label [htmlFor]="'name'">الإسم</label>
                                        <input
                                            formControlName="name"
                                            [pAutoFocus]="true"
                                            [autofocus]="true"
                                            class="min-w-full"
                                            (focus)="selectOnFocus($event)"
                                            pInputText
                                            id="name" />
                                    </span>
                                </div>
                                <!--            CODE-->
                                <div class="col-lg-6 mb-5">
                                    <span class="p-float-label">
                                        <label [htmlFor]="'code'">الكود</label>
                                        <input
                                            formControlName="code"
                                            class="min-w-full"
                                            (focus)="selectOnFocus($event)"
                                            pInputText
                                            id="code" />
                                    </span>
                                </div>
                                <!--            EMAIL-->
                                <div class="col-lg-6 mb-5">
                                    <span class="p-float-label">
                                        <label [htmlFor]="'email'">البريد</label>
                                        <input
                                            formControlName="email"
                                            class="min-w-full"
                                            (focus)="selectOnFocus($event)"
                                            pInputText
                                            id="email" />
                                    </span>
                                </div>
                                <!-- PHONE NUMBER  -->
                                <div class="col-lg-6 mb-5">
                                    <span class="p-float-label">
                                        <label [htmlFor]="'phoneNumber'">رقم الجوال</label>
                                        <input
                                            formControlName="phoneNumber"
                                            class="min-w-full"
                                            (focus)="selectOnFocus($event)"
                                            placeholder="05XXXXXXXX"
                                            pInputText
                                            id="phoneNumber" />
                                    </span>
                                </div>
                                <!-- OPENING BALANCE -->
                                <div class="col-lg-6 mb-5">
                                    <span class="p-float-label">
                                        <label for="openingBalance">الرصيد الابتدائي</label>
                                        <p-inputNumber
                                            [style]="{ width: '100%' }"
                                            inputId="openingBalance"
                                            (onFocus)="selectOnFocus($event)"
                                            mode="decimal"
                                            [minFractionDigits]="2"
                                            [maxFractionDigits]="2"
                                            formControlName="openingBalance">
                                        </p-inputNumber>
                                    </span>
                                </div>
                                <!-- OPENING BALANCE DATE-->
                                <div class="col-lg-6 mb-5">
                                    <span class="p-float-label">
                                        <label for="openingBalanceDate">تاريخ الرصيد الابتدائي</label>
                                        <p-date-picker
                                            class="w-full"
                                            (onSelect)="onDateSelect($event)"
                                            [dateFormat]="'yy-mm-dd'"
                                            formControlName="openingBalanceDate"
                                            [maxDate]="maxDate"
                                            [iconDisplay]="'input'"
                                            [showIcon]="true"
                                            inputId="openingBalanceDate"></p-date-picker>
                                    </span>
                                </div>
                                <!-- VAT NUMBER  -->
                                <div class="col-lg-6 mb-5">
                                    <span class="p-float-label">
                                        <label [htmlFor]="'vatNumber'">الرقم الضريبي</label>
                                        <input
                                            formControlName="vatNumber"
                                            class="min-w-full"
                                            (focus)="selectOnFocus($event)"
                                            pInputText
                                            id="vatNumber" />
                                    </span>
                                </div>
                                <!-- COMMERCIAL REGISTER  -->
                                <div class="col-lg-6 mb-5">
                                    <span class="p-float-label">
                                        <label [htmlFor]="'commercialRegister'">السجل التجاري</label>
                                        <input
                                            formControlName="commercialRegister"
                                            class="w-full"
                                            (focus)="selectOnFocus($event)"
                                            pInputText
                                            id="commercialRegister" />
                                    </span>
                                </div>
                                <!-- IS B2B CHECKBOX -->
                                <div class="col-lg-12 mb-5">
                                    <div class="field-checkbox">
                                        <p-checkbox formControlName="isB2B" [binary]="true" inputId="isB2B">
                                        </p-checkbox>
                                        <label for="isB2B" class="mr-2">عميل تجاري (B2B)</label>
                                    </div>
                                </div>

                                <!-- B2B ADDRESS FIELDS -->
                                <ng-container *ngIf="customForm.get('isB2B')?.value">
                                    <!-- BUILDING NUMBER -->
                                    <div class="col-lg-6 mb-5">
                                        <span class="p-float-label">
                                            <label [htmlFor]="'buildingNumber'">رقم المبنى</label>
                                            <input
                                                formControlName="buildingNumber"
                                                class="w-full"
                                                (focus)="selectOnFocus($event)"
                                                pInputText
                                                id="buildingNumber" />
                                        </span>
                                    </div>
                                    <!-- ADDITIONAL NUMBER -->
                                    <div class="col-lg-6 mb-5">
                                        <span class="p-float-label">
                                            <label [htmlFor]="'additionalNumber'">الرقم الإضافي</label>
                                            <input
                                                formControlName="additionalNumber"
                                                class="w-full"
                                                (focus)="selectOnFocus($event)"
                                                pInputText
                                                id="additionalNumber" />
                                        </span>
                                    </div>
                                    <!-- STREET NAME -->
                                    <div class="col-lg-6 mb-5">
                                        <span class="p-float-label">
                                            <label [htmlFor]="'streetName'">اسم الشارع</label>
                                            <input
                                                formControlName="streetName"
                                                class="w-full"
                                                (focus)="selectOnFocus($event)"
                                                pInputText
                                                id="streetName" />
                                        </span>
                                    </div>
                                    <!-- CITY -->
                                    <div class="col-lg-6 mb-5">
                                        <span class="p-float-label">
                                            <label [htmlFor]="'city'">المدينة</label>
                                            <input
                                                formControlName="city"
                                                class="w-full"
                                                (focus)="selectOnFocus($event)"
                                                pInputText
                                                id="city" />
                                        </span>
                                    </div>
                                    <!-- DISTRICT -->
                                    <div class="col-lg-6 mb-5">
                                        <span class="p-float-label">
                                            <label [htmlFor]="'district'">الحي</label>
                                            <input
                                                formControlName="district"
                                                class="w-full"
                                                (focus)="selectOnFocus($event)"
                                                pInputText
                                                id="district" />
                                        </span>
                                    </div>
                                    <!-- ZIP -->
                                    <div class="col-lg-6 mb-5">
                                        <span class="p-float-label">
                                            <label for="zip">الرمز البريدي</label>
                                            <p-inputNumber
                                                [style]="{ width: '100%' }"
                                                inputId="zip"
                                                (onFocus)="selectOnFocus($event)"
                                                mode="decimal"
                                                [useGrouping]="false"
                                                formControlName="zip">
                                            </p-inputNumber>
                                        </span>
                                    </div>
                                    <!-- COUNTRY KEY -->
                                    <div class="col-lg-6 mb-5">
                                        <span class="p-float-label">
                                            <label [htmlFor]="'countryKey'">رمز البلد</label>
                                            <input
                                                formControlName="countryKey"
                                                class="w-full"
                                                maxlength="2"
                                                [disabled]="true"
                                                (focus)="selectOnFocus($event)"
                                                pInputText
                                                id="countryKey" />
                                        </span>
                                    </div>
                                </ng-container>

                                <!-- REGULAR ADDRESS (B2C) -->
                                <div class="col-lg-12 mb-5" *ngIf="!customForm.get('isB2B')?.value">
                                    <span class="p-float-label">
                                        <label [htmlFor]="'address'">العنوان</label>
                                        <input
                                            formControlName="address"
                                            class="w-full"
                                            (focus)="selectOnFocus($event)"
                                            pInputText
                                            id="address" />
                                    </span>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <p-divider />
                <div class="form-actions">
                    <p-button
                        [outlined]="true"
                        [routerLink]="['/customers']"
                        severity="secondary"
                        class=""
                        label="رجوع" />
                    <p-button (onClick)="save()" [disabled]="customForm.invalid || btnSaved" label="حفظ" />
                </div>
            </div>
        </div>
    </div>
</section>
<p-toast></p-toast>
